import { ElementRef, signal, Service } from '@angular/core';

@Service()
export class MapService {
  private readonly _isLoading = signal(true);
  readonly isLoading = this._isLoading.asReadonly();

  private readonly _map = signal<ElementRef<HTMLArcgisMapElement> | undefined>(undefined);
  readonly map = this._map.asReadonly();

  setIsLoading(isLoading: boolean) {
    this._isLoading.set(isLoading);
  }

  setMap(map: ElementRef<HTMLArcgisMapElement>) {
    this._map.set(map);
  }
}
